/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {getUserByToken, resetPassword} from '../core/_requests'

import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'

import {useAuth} from '../core/Auth'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'

const initialValues = {
  token: '',
  password: '',
  confirm_password: '',
}

export function ResetPassword() {
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const resetPasswordSchema = Yup.object().shape({
    token: Yup.string()
      .min(6, intl.formatMessage({id: 'AUTH.RESET.TOKEN_MIN'}))
      .max(6, intl.formatMessage({id: 'AUTH.RESET.TOKEN_MAX'}))
      .required(intl.formatMessage({id: 'AUTH.RESET.TOKEN_REQUIRED'})),
    password: Yup.string()
      .min(8, intl.formatMessage({id: 'AUTH.RESET.PASSWORD_MIN'}))
      .max(50, intl.formatMessage({id: 'AUTH.RESET.PASSWORD_MAX'}))
      .required(intl.formatMessage({id: 'AUTH.RESET.PASSWORD_REQUIRED'})),
    confirm_password: Yup.string()
      .required(intl.formatMessage({id: 'AUTH.RESET.PASSWORD.CONFIRMATION_REQUIRED'}))
      .oneOf([Yup.ref('password'), null], intl.formatMessage({id: 'AUTH.RESET.PASSWORD_MATCH'})),
    // acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await resetPassword(
          values.token,
          values.password,
          values.confirm_password
        )
        saveAuth(auth)
        const {data: user} = await getUserByToken()
        setCurrentUser(user)

        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'AUTH.RESET.PASSWORD.SUCCESS'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/')
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus(intl.formatMessage({id: 'AUTH.RESET.PASSWORD.ERROR'}))
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])
  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group Password */}
      <div className='fv-row mb-8' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>
            {intl.formatMessage({id: 'AUTH.INPUT.NEW_PASSWORD'})}
          </label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder={intl.formatMessage({id: 'AUTH.RESET.PASSWORD_PLACEHOLDER'})}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>
          {intl.formatMessage({id: 'AUTH.RESET.PASSWORD_INSTRUCTIONS'})}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {intl.formatMessage({id: 'AUTH.RESET.PASSWORD.CONFIRMATION'})}
        </label>
        <input
          type='password'
          placeholder={intl.formatMessage({id: 'AUTH.RESET.PASSWORD.CONFIRMATION_PLACEHOLDER'})}
          autoComplete='off'
          {...formik.getFieldProps('confirm_password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.confirm_password && formik.errors.confirm_password,
            },
            {
              'is-valid': formik.touched.confirm_password && !formik.errors.confirm_password,
            }
          )}
        />
        {formik.touched.confirm_password && formik.errors.confirm_password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.confirm_password}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {intl.formatMessage({id: 'AUTH.RESET.TOKEN'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'AUTH.RESET.TOKEN_PLACEHOLDER'})}
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('token')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.token && formik.errors.token},
            {
              'is-valid': formik.touched.token && !formik.errors.token,
            }
          )}
        />
        {formik.touched.token && formik.errors.token && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.token}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && (
            <span className='indicator-label'>
              {intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
            </span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            {intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'})}
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
